import Api from "../common/Api";
import { ApiUrlUtil } from "../../utils/apiUrlUtil";
import { YyRdcGoalModel } from "app/model/cp/yyRdcGoal";
import axios from "axios";
import { HeadersUtil } from "app/utils/headersUtil";
import {ActvSelectType, RoadmapType} from "../../model/cp/Roadmap";

export class RoadMapService extends Api {
  private static service: RoadMapService;
  private static reduceGoalUrl: string = process.env.REACT_APP_URL_CP + "/roadMap/reduceGoal";
  private static activeData: string = process.env.REACT_APP_URL_CP + "/roadMap/activeData";

  public static getInstance(): RoadMapService {
    if (!RoadMapService.service) {
      RoadMapService.service = new RoadMapService();
    }
    return RoadMapService.service;
  }

  public async getUserLastYyRdcGoal() {
    const url = ApiUrlUtil.buildQueryString(RoadMapService.reduceGoalUrl);
    return await super.get<YyRdcGoalModel>(url);
  }

  public async saveYyRdcGoal(data: any) {
    const url = ApiUrlUtil.buildQueryString(RoadMapService.reduceGoalUrl);
    return await super.post<any>(url, data);
  }

  public async getRoadmap() {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + "/comprehenStatus/getRoadmap"
    );
    return await super.get<RoadmapType>(url);
  }

  public async getActvSelectbox() {
    const url = ApiUrlUtil.buildQueryString(
        process.env.REACT_APP_URL_CP + "/comprehenStatus/actv"
    );
    return await super.get<ActvSelectType>(url);
  }

  public getActiveData() {
    const url = ApiUrlUtil.buildQueryString(RoadMapService.activeData);
    return axios.get(url, {
      headers: HeadersUtil.getHeaders(),
    });
  }
}
